import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ReactTyped } from "react-typed";
import Header from "../Header/Header";
import "../../styles/style.css";
import "../../styles/pulse.css";
// import Sidebar from "./sidebar";
import io from 'socket.io-client';
import user from "../../assets/images/undraw_profile.svg";
import bot from "../../assets/images/aibot.jpg";
import styles from "./Message/Message.module.css";
import { getHistory } from '../../services/apiService';
import BlinkingDots from "./BlinkingDots";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const token = localStorage.getItem('token'); // Retrieve token from local storage

const socket = io.connect(`${BASE_URL}`, {
  extraHeaders: {
    Authorization: `Bearer ${token}`,
  },
});

const PulseAi = () => {
  const [message, setMessage] = useState('');
  const [conversation, setConversation] = useState([]); // Store conversation history
  const listRef = useRef(null);
  const [username, setUsername] = useState("");
  const [lastname, setLastname] = useState("");
  const [isTyping, setIsTyping] = useState(false); // Track if the bot is typing
  

  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    const storeLastname = localStorage.getItem("lastname");
    setUsername(storedUsername || "");
    setLastname(storeLastname || "");
    // Listening for messages from the server
    socket.on('message', (msg) => {
      setConversation(prevConversation => [...prevConversation, { role: 'server', content: msg }]);
      setIsTyping(false);
      fetchHistory();
    });

    return () => {
      socket.off('message'); // Clean up listener on component unmount
    };
  }, []);

  const sendMessage = () => {
    if (message.trim()) {
      // Add sent message to conversation
      setConversation(prevConversation => [...prevConversation, { role: 'user', content: message }]);
      socket.send(message); // Send message to the server
      setIsTyping(true);
      setMessage(''); // Clear input field
    }
  };

  useEffect(() => {       
    listRef.current?.lastElementChild?.scrollIntoView()
}, [conversation]);

const [newDataHistory, setDataHistory] = useState([]);
  const fetchHistory = async () => {
    try {
      const response = await getHistory();
      setDataHistory (response.data.data);
    } catch (error) {
      console.error('Error fetching History data:', error);
    }
  };
  
  useEffect(() => {
    fetchHistory();
  }, []);

  return (
    <>
      <Header />
      <div className="container">
        <nav style={{ "--bs-breadcrumb-divider": ">" }} aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="#"></Link>
            </li>
          </ol>
        </nav>
      </div>
      <div className="container pb-4">
        <div className="row">
          <div className="col-md-9">
            <div className="ig-forms" style={{ height: "calc(100vh - 200px)" }}>
              <div className="row">
                <div className="col-md-12">
                  <div className="tile">
                    <div className="messanger">
                      <div className="messages"  ref={listRef}>
                        <div className={styles.wrapper}>
                          <div>
                            <img
                              src={bot}
                              className={styles.avatar}
                              alt="profile avatar"
                            />
                          </div>
                          <p>
                            <ReactTyped
                              strings={[`Welcome ${username} ${lastname}`]}  // Use template literals for dynamic values
                              typeSpeed={25}
                              loop={false}
                              showCursor={false}
                            />
                          </p>
                        </div>
                      {conversation.map((el, i) => (
                          <div className={styles.wrapper} key={i}>
                            <div>
                              <img
                                src={el.role === "server" ? bot : user}
                                className={styles.avatar}
                                alt="profile avatar"
                              />
                            </div>
                            <p>
                              {/* {el.role === 'user' ? el.content : <ReactTyped strings={[el.content]} typeSpeed={25} loop={false} showCursor={false} />} */}
                              {/* {el.role === 'user' ? el.content : el.content.split('\n').map((line, index) => (
                                  <div key={index} style={{ whiteSpace: 'pre-wrap' }}><ReactTyped strings={[line]} typeSpeed={25} loop={false} showCursor={false} /></div>
                                ))
                              } */}
                              {el.role === 'user' ? el.content : el.content.split('\n').map((line, index) => (
                                  <div key={index} style={{ whiteSpace: 'pre-wrap' }}>{line}</div>
                                ))
                              }
                            </p>
                          </div>
                        ))}
                        {isTyping && (
                          <div className={styles.wrapper}>
                            <div>
                              <img
                                src={bot}
                                className={styles.avatar}
                                alt="profile avatar"
                              />
                            </div>
                            <p>
                            <BlinkingDots />
                            </p>
                          </div>
                        )}
                      </div>
                      <div>
                        <div className="sender">
                        <input 
                          type="text" 
                          className="form-control"
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          placeholder="Type your message..."
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              sendMessage(); // Call sendMessage on Enter key press
                            }
                          }}
                        />
                          <button className="btn btn-primary" onClick={sendMessage}>Send</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 side-ox-row">
          <div className="sidebar-box mb-2">
            <div className="side-bar-bx">
              <ul style={{ padding : "10px", textAlign: "center" }}>
                <li className="sidebar-heading">
                  My Question
                </li>
                {newDataHistory.map((el, i) => (
                  <li className="history">
                  {el.request}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default PulseAi;
